export default __webpack_public_path__ + "static/media/arrow.8be81ffc.svg";